var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60.923,
    height: 36.308,
    x: 1.538,
    y: 14.153,
    ry: 3.077,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 3.077
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23 42.77V21.846h6.154l6.154 7.692 6.154-7.692h6.154V42.77h-6.154v-12l-6.154 7.692-6.154-7.692v12zm38.462 0l-9.23-10.154h6.154v-10.77h6.154v10.77h6.154z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkdown);
export default __webpack_public_path__ + "static/media/markdown.90d2a8d00e325b26a15fb4f62f938f41.svg";
export { ForwardRef as ReactComponent };